import {
  CreateGUFStartRegistrationTask,
  EditGUFStartRegistrationTask,
} from "@nens/brostar/uploadapi-client";
import { SchemaForFormData } from "@nens/shared-utils";

import { getDocsLinkMarkdown, getTitleAddon } from "@/libs/form-utils";
import { FormType } from "@/types/form-types";

import { pickGufLibraryFields } from "./guf-schema-library";

const sharedTitle = (type: FormType | undefined) =>
  `GUF Grondwatergebruiksysteem ${getTitleAddon(type)}`;
const sharedDescription = `Dit is het GUF startregistratie formulier. ${getDocsLinkMarkdown(
  "GUF"
)}`;

const sharedSourcedocumentData = {
  type: "object" as const,
  title: "Brondocumentgegevens",
  required: [
    "objectIdAccountableParty",
    "deliveryContext",
    "startTime",
    "identificationLicence",
    "legalType",
    "primaryUsageType",
    "humanConsumption",
  ],
  properties: {
    ...pickGufLibraryFields([
      "objectIdAccountableParty",
      "deliveryContext",
      "startTime",
      "identificationLicence",
      "legalType",
      "primaryUsageType",
      "secondaryUsageTypes",
      "humanConsumption",
      "licensedQuantities",
      "designInstallations",
    ]),
  },
};

const getGufStartRegistrationCreateSchema = (
  type: FormType | undefined
): SchemaForFormData<CreateGUFStartRegistrationTask> => ({
  // broId does not exist yet here, it will be created by the BRO after this message is sent
  type: "object",
  title: sharedTitle(type),
  description: sharedDescription,
  required: ["metadata", "sourcedocumentData"],
  properties: {
    metadata: {
      type: "object",
      title: "Metadata",
      required: ["projectNumber", "deliveryAccountableParty", "qualityRegime"],
      properties: pickGufLibraryFields([
        "projectNumber",
        "qualityRegime",
        "deliveryAccountableParty",
      ]),
    },
    sourcedocumentData: sharedSourcedocumentData,
  },
});

const getGufStartRegistrationEditSchema = (
  type: FormType | undefined
): SchemaForFormData<EditGUFStartRegistrationTask> => ({
  type: "object",
  title: sharedTitle(type),
  description: sharedDescription,
  required: ["metadata", "sourcedocumentData"],
  properties: {
    metadata: {
      type: "object",
      title: "Metadata",
      required: [
        "projectNumber",
        "deliveryAccountableParty",
        "qualityRegime",
        "broId",
        "correctionReason",
      ],
      properties: {
        ...pickGufLibraryFields([
          "projectNumber",
          "qualityRegime",
          "deliveryAccountableParty",
          "correctionReason",
        ]),
        broId: { ...pickGufLibraryFields(["broId"]).broId, readOnly: true },
      },
    },
    sourcedocumentData: sharedSourcedocumentData,
  },
});

export function getGufStartRegistrationSchema(args: {
  type: FormType | undefined;
  isEditing: true;
}): SchemaForFormData<EditGUFStartRegistrationTask>;
export function getGufStartRegistrationSchema(args: {
  type: FormType | undefined;
  isEditing: false;
}): SchemaForFormData<CreateGUFStartRegistrationTask>;
export function getGufStartRegistrationSchema(args: {
  type: FormType | undefined;
  isEditing: boolean;
}):
  | SchemaForFormData<EditGUFStartRegistrationTask>
  | SchemaForFormData<CreateGUFStartRegistrationTask>;
export function getGufStartRegistrationSchema({
  type,
  isEditing,
}: {
  type: FormType | undefined;
  isEditing: boolean;
}) {
  return isEditing
    ? getGufStartRegistrationEditSchema(type)
    : getGufStartRegistrationCreateSchema(type);
}
